export enum MeetingsPagePermissions {
  reviewerMeetings = 'reviewerMeetings',
  subordinateMeetings = 'subordinateMeetings',
}
